import { Routes } from '@angular/router';
import {AddonDetailsComponent} from './addon-details/addon-details.component';
import {AddonOverviewComponent} from './addon-overview/addon-overview.component';

export const addonRoutes: Routes = [
  { path: 'details/:id', component: AddonDetailsComponent},
  { path: '', component: AddonOverviewComponent}
];
